import { Link } from 'react-router-dom';
import Logo from '../assets/images/Logo.svg';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import vqeMethod from '../assets/images/vqe_method.svg';

function PfasArchitecture() {
  return (
    <>
      <div className='navigation'>
        <div className='logo'>
          <img src={Logo} alt='Quantum logo' />
        </div>
        <div className='nav'>
          <Link to='/molecules' className='pfas-btn-white-back'>
            <div className='nav-text-back'>Previous</div>
          </Link>
          <Link to='/'>
            <div className='nav-home'></div>
          </Link>
          <Link to='/conclusion' className='pfas-btn-white-next-conclusion '>
            <div className='nav-text-next-dark'>Conclusion</div>
          </Link>
        </div>
      </div>
      <div className='pfas-architecture pfas-container'>
        <Row>
          <div className='solution'>
            <Col xs={12} lg={6}>
              <div className='text-left'>
                <div className='slogan'>Architecture</div>
                <div className='headline'>Solution</div>

                <ul>
                  <li className='list-text'>
                    We solved the electronic structure problem using{' '}
                    <b>variational quantum eigensolvers (VQEs)</b> with wide
                    selections of solver parameters. We implemented the solution
                    with software libraries such as <b>OpenFermion</b>,{' '}
                    <b>Tequila</b>, <b>Dask</b>, etc.
                  </li>
                  <li className='list-text'>
                    We built a novel scalable <b>quantum chemistry platform</b>{' '}
                    that allows running end-to-end chemistry experiments on HPC
                    and quantum computers.
                  </li>
                  <li className='list-text'>
                    We utilized <b>AWS DynamoDB</b> to store experimental
                    parameters and results for future usability and analysis.
                  </li>
                  <li className='list-text'>
                    We built a web-based <b>demo application</b> to fetch the
                    results and visualize them.
                  </li>
                </ul>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <div className='image-right'>
                <div className='heading'>VQE Method</div>
                <div className='vqe-method'>
                  <img src={vqeMethod} alt='vqe method' />
                </div>
              </div>
            </Col>
          </div>

          <Row>
            <Col>
              <div className='headline-process'>Experiment Process</div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className='boxes'>
                {/* <div className='heading'>Experiment Process</div> */}
                <br />
                <div className='single-box'>
                  <div className='box-number'>1.</div>
                  <div className='box-text'>
                    Load Experiment Data, Create Geometries and Fermionic
                    Hamiltonian [Psi4]
                  </div>
                </div>
                <div className='box-arrow'></div>
                <div className='single-box'>
                  <div className='box-number'>2.</div>
                  <div className='box-text'>
                    Create Second Quantization Hamiltonian, Active Space
                    Reduction [OpenFermion]
                  </div>
                </div>
                <div className='box-arrow'></div>
                <div className='single-box'>
                  <div className='box-number'>3.</div>
                  <div className='box-text'>
                    Create Qubit Hamiltonians, Qubit Tapering [OpenFermion]
                  </div>
                </div>
                <div className='box-arrow'></div>
                <div className='single-box'>
                  <div className='box-number'>4.</div>
                  <div className='box-text'>
                    Create VQE Circuit, State Preparation, Circuit Optimization
                    [Tequila]
                  </div>
                </div>
                <div className='box-arrow-4'></div>

                <div className='line-with-arrow'>
                  <div className='vertical-line_a'>
                    <div className='box-line-vertical'></div>
                  </div>
                  <div className='box-line'></div>
                  <div className='vertical-line_b'>
                    <div className='box-arrow-vertical'></div>
                  </div>
                </div>
                <div className='single-box'>
                  <div className='box-number'>5.</div>
                  <div className='box-text'>
                    Create Dask graph, Schedule Experiments on HPC or QPU
                  </div>
                </div>
                <div className='box-arrow'></div>

                <div className='single-box'>
                  <div className='box-number'>6.</div>
                  <div className='box-text'>
                    Run Experiments on IonQ Computer or HPC Simulator
                  </div>
                </div>
                <div className='box-arrow'></div>

                <div className='single-box'>
                  <div className='box-number'>7.</div>
                  <div className='box-text'>
                    Collect Results, Store in AWS DynamoDB
                  </div>
                </div>
                <div className='box-arrow'></div>

                <div className='single-box'>
                  <div className='box-number'>8.</div>
                  <div className='box-text'>
                    Load Results, Analyze, Visualize [React, Flask]
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export default PfasArchitecture;
